<template>
  <!-- 添加线索 -->
  <div class="add-clue" v-loading="loading">
    <!-- 基础信息表单 -->
    <el-form
      ref="baseForm"
      :model="formData"
      label-width="120px"
      class="base-form"
    >
      <div class="add-clue-title">线索信息</div>
      <div class="form-grid">
        <el-form-item
          label="新增线索给"
          prop="assignTo"
          :rules="[
            { required: true, message: '请选择新增线索给', trigger: 'change' }
          ]"
        >
          <el-select
            style="width: 100%;"
            :disabled="createClueIsSuccess"
            v-model="formData.assignTo"
            placeholder="请选择"
            size="small"
            class="form-select"
          >
            <el-option label="跟进人" value="follower"></el-option>
            <el-option label="公海-推进池" value="public"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="isCreateToFollower"
          label="选择跟进人"
          prop="follower"
          :rules="[
            { required: true, message: '请选择跟进人', trigger: 'change' }
          ]"
        >
          <el-select
            style="width: 100%;"
            v-model="formData.follower"
            placeholder="请选择"
            :disabled="createClueIsSuccess"
            filterable
            remote
            :remote-method="remoteSearchEmployee"
            :loading="employeeLoading"
            size="small"
            class="form-select"
          >
            <el-option v-for="item in filteredEmployeeOptions" :key="item.workNumber" :label="item.nickName" :value="item.workNumber"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="add-clue-title">医生信息</div>
      <div class="form-grid">
        <!-- 医生姓名 -->
        <custom-form-item
          type="input"
          prop="doctor_name_formCode_FR001"
          v-model="formData.doctor_name_formCode_FR001"
          :fieldInfo="showFormFieldKeyInfo.doctor_name_formCode_FR001 || {}"
          @change="changeHandle($event, 'doctor_name_formCode_FR001')"
        />
        <!-- 性别 -->
        <custom-form-item
          type="select"
          prop="sex_formCode_FR001"
          v-model="formData.sex_formCode_FR001"
          :options="originOptionsInfo.sex_formCode_FR001 || []"
          :fieldInfo="showFormFieldKeyInfo.sex_formCode_FR001 || {}"
          @change="changeHandle($event, 'sex_formCode_FR001')"
        />
      </div>
      <div
        v-for="(item, index) in seePatientList"
        :key="item.uuid"
      >
        <el-form
          :model="item"
          ref="seePatientCreateForm"
          label-width="120px"
        >
          <div class="form-grid">
            <!-- 坐诊医院 -->
            <custom-form-item
              type="input"
              prop="hospital_formCode_FR015"
              v-model="item.hospital_formCode_FR015"
              :fieldInfo="{
                ...(showFormFieldKeyInfo.hospital_formCode_FR015 || {}),
                zhName: ((showFormFieldKeyInfo.hospital_formCode_FR015 || {}).zhName || '坐诊医院') + (index + 1)
              }"
              @change="changeHandle($event, 'hospital_formCode_FR015', index)"
            />
            <!-- 科室 -->
            <custom-form-item
              type="input"
              prop="department_formCode_FR015"
              v-model="item.department_formCode_FR015"
              :fieldInfo="showFormFieldKeyInfo.department_formCode_FR015 || {}"
              @change="changeHandle($event, 'department_formCode_FR015', index)"
            />
            <!-- 删除图标 -->
            <i v-if="seePatientList.length > 1" class="el-icon-delete" @click="deleteSeePatientFormData(item, index)"></i>
          </div>
        </el-form>
      </div>
      <div class="see-patient-btn">
        <!-- 添加坐诊信息 -->
        <span class="add-see-patient-btn" @click="createSeePatientFormData">+ 新增坐诊信息</span>
      </div>
    </el-form>

    <!-- 标签页切换按钮 -->
    <div v-if="!isExpanded" class="tab-toggle">
      <span class="toggle-btn" @click="isExpanded = !isExpanded">
        <span>填写更多线索信息</span>
        <i :class="isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </span>
    </div>

    <!-- 展开的标签页内容 -->
    <div v-if="isExpanded" class="expand-content">
      <!-- 粘性标签页 -->
      <el-tabs v-model="activeTab" class="clue-tabs">
        <el-tab-pane label="基本信息" name="basic"></el-tab-pane>
        <el-tab-pane label="坐诊信息" name="seePatient"></el-tab-pane>
        <el-tab-pane v-if="isCreateToFollower" label="辅助信息" name="assistant"></el-tab-pane>
        <el-tab-pane v-if="isCreateToFollower" label="医生期望" name="doctorWish"></el-tab-pane>
      </el-tabs>

      <!-- 标签页内容区域 -->
      <div class="tab-content-area">
        <!-- 基本信息 -->
        <div v-show="activeTab === 'basic'" class="tab-section">
          <el-form
            ref="baseInfoForm"
            :model="formData"
            label-width="120px"
          >
            <div class="form-grid">
              <!-- 医生姓名 -->
              <custom-form-item
                type="input"
                prop="doctor_name_formCode_FR900"
                v-model="formData.doctor_name_formCode_FR900"
                :fieldInfo="showFormFieldKeyInfo.doctor_name_formCode_FR900 || {}"
                @change="changeHandle($event, 'doctor_name_formCode_FR900')"
              />
              <!-- 性别 -->
              <custom-form-item
                type="select"
                prop="sex_formCode_FR900"
                v-model="formData.sex_formCode_FR900"
                :options="originOptionsInfo.sex_formCode_FR900 || []"
                :fieldInfo="showFormFieldKeyInfo.sex_formCode_FR900 || {}"
                @change="changeHandle($event, 'sex_formCode_FR900')"
              />
              <!-- 手机号 -->
              <custom-form-item
                type="input"
                prop="phone_formCode_FR900"
                v-model="formData.phone_formCode_FR900"
                :fieldInfo="showFormFieldKeyInfo.phone_formCode_FR900 || {}"
              />
              <!-- 微信号 -->
              <custom-form-item
                type="input"
                prop="wxid_formCode_FR900"
                v-model="formData.wxid_formCode_FR900"
                :fieldInfo="showFormFieldKeyInfo.wxid_formCode_FR900 || {}"
              />
              <!-- 年龄 -->
              <custom-form-item
                type="input"
                prop="age_formCode_FR900"
                v-model="formData.age_formCode_FR900"
                :fieldInfo="showFormFieldKeyInfo.age_formCode_FR900 || {}"
                @change="changeAgeOrBirchdayHandle($event, 'age')"
              />
              <!-- 出生日期 -->
              <el-form-item
                v-if="(showFormFieldKeyInfo.birth_formCode_FR900 || {}).isShow"
                :label="(showFormFieldKeyInfo.birth_formCode_FR900 || {}).zhName"
              >
                <el-date-picker
                  style="width: 100%;"
                  v-model="formData.birth_formCode_FR900"
                  type="date"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  size="small"
                  class="form-input"
                  @change="changeAgeOrBirchdayHandle($event, 'birthday')"
                />
              </el-form-item>
              <!-- 籍贯 -->
              <custom-form-item
                type="cascader"
                prop="province_native_place_formCode_FR900"
                :cascaderProps="{
                  value: 'code',
                  label: 'name',
                  children: 'list'
                }"
                v-model="formData.province_native_place_formCode_FR900"
                label="籍贯"
                :cascaderOptions="areaList || []"
                :fieldInfo="showFormFieldKeyInfo.province_native_place_formCode_FR900 || {}"
              />
              <!-- 毕业院校 -->
              <custom-form-item
                type="input"
                prop="school_formCode_FR900"
                v-model="formData.school_formCode_FR900"
                :fieldInfo="showFormFieldKeyInfo.school_formCode_FR900 || {}"
              />
              <!-- 职称 -->
              <custom-form-item
                type="select"
                prop="aa_formCode_FR900"
                v-model="formData.aa_formCode_FR900"
                :options="originOptionsInfo.aa_formCode_FR900 || []"
                :fieldInfo="showFormFieldKeyInfo.aa_formCode_FR900 || {}"
              />
              <!-- 荣誉称号 -->
              <custom-form-item
                type="multiple-select"
                prop="ab_formCode_FR900"
                v-model="formData.ab_formCode_FR900"
                filterable
                :options="originOptionsInfo.ab_formCode_FR900 || []"
                :fieldInfo="showFormFieldKeyInfo.ab_formCode_FR900 || {}"
              />
              <!-- 师承 -->
              <custom-form-item
                type="input"
                prop="inherit_formCode_FR900"
                v-model="formData.inherit_formCode_FR900"
                :fieldInfo="showFormFieldKeyInfo.inherit_formCode_FR900 || {}"
              />
              <!-- 治疗方式 -->
              <custom-form-item
                type="multiple-select"
                prop="physio_type_formCode_FR900"
                v-model="formData.physio_type_formCode_FR900"
                filterable
                :options="originOptionsInfo.physio_type_formCode_FR900 || []"
                :fieldInfo="showFormFieldKeyInfo.physio_type_formCode_FR900 || {}"
              />
              <!-- 外治占比 -->
              <custom-form-item
                type="input"
                prop="physio_rate_formCode_FR900"
                v-model="formData.physio_rate_formCode_FR900"
                :fieldInfo="showFormFieldKeyInfo.physio_rate_formCode_FR900 || {}"
              />
              <!-- 月收入 -->
              <custom-form-item
                type="select"
                prop="income_month_amount_formCode_FR900"
                v-model="formData.income_month_amount_formCode_FR900"
                :options="originOptionsInfo.income_month_amount_formCode_FR900 || []"
                :fieldInfo="showFormFieldKeyInfo.income_month_amount_formCode_FR900 || {}"
              />
              <!-- 月度销售额(自述) -->
              <custom-form-item
                type="input"
                prop="month_sale_amount_formCode_FR900"
                v-model="formData.month_sale_amount_formCode_FR900"
                :fieldInfo="showFormFieldKeyInfo.month_sale_amount_formCode_FR900 || {}"
              />
              <!-- 介绍人 -->
              <custom-form-item
                type="input"
                prop="referrer_formCode_FR900"
                v-model="formData.referrer_formCode_FR900"
                :fieldInfo="showFormFieldKeyInfo.referrer_formCode_FR900 || {}"
              />
            </div>
          </el-form>
        </div>

        <!-- 坐诊信息 -->
        <div v-show="activeTab === 'seePatient'" class="tab-section">
          <div class="see-patient-tab">
            <div class="see-patient-tab-content">
              <span
                class="see-patient-tab-item"
                v-for="(item, index) in seePatientList"
                :key="item.uuid"
                :class="{ 'active': activeSeePatientTabIndex === index }"
                @click="activeSeePatientTabIndex = index"
              >坐诊信息{{ index + 1 }}</span>
            </div>
          </div>
          <div
            v-for="(item, index) in seePatientList"
            :key="item.uuid"
            v-show="activeSeePatientTabIndex === index"
          >
            <el-form
              ref="seePatientTabForms"
              :model="item"
              label-width="120px"
            >
              <div class="form-grid">
                <!-- 坐诊医院 -->
                <custom-form-item
                  type="input"
                  prop="hospital_formCode_FR903"
                  v-model="item.hospital_formCode_FR903"
                  :fieldInfo="{
                    ...(showFormFieldKeyInfo.hospital_formCode_FR903 || {}),
                    zhName: ((showFormFieldKeyInfo.hospital_formCode_FR903 || {}).zhName || '坐诊医院') + (index + 1)
                  }"
                  @change="changeHandle($event, 'hospital_formCode_FR903', index)"
                />
                <!-- 医院行政区域 -->
                <custom-form-item
                  type="cascader"
                  prop="province_formCode_FR903"
                  :cascaderProps="{
                    value: 'code',
                    label: 'name',
                    children: 'list'
                  }"
                  v-model="item.province_formCode_FR903"
                  label="医院行政区域"
                  :cascaderOptions="cityList || []"
                  :fieldInfo="showFormFieldKeyInfo.province_formCode_FR903 || {}"
                  @change="changeHandle($event, 'province_formCode_FR903', index)"
                />
                <!-- 医院详细地址 -->
                <custom-form-item
                  type="input"
                  prop="hospital_address_formCode_FR903"
                  v-model="item.hospital_address_formCode_FR903"
                  :fieldInfo="showFormFieldKeyInfo.hospital_address_formCode_FR903 || {}"
                />
                <!-- 科室 -->
                <custom-form-item
                  type="input"
                  prop="department_formCode_FR903"
                  v-model="item.department_formCode_FR903"
                  :fieldInfo="showFormFieldKeyInfo.department_formCode_FR903 || {}"
                />
                <!-- 简介 -->
                <custom-form-item
                  type="input"
                  prop="synopsis_formCode_FR903"
                  v-model="item.synopsis_formCode_FR903"
                  :fieldInfo="showFormFieldKeyInfo.synopsis_formCode_FR903 || {}"
                />
                <!-- 擅长 -->
                <custom-form-item
                  type="input"
                  prop="virtue_formCode_FR903"
                  v-model="item.virtue_formCode_FR903"
                  :fieldInfo="showFormFieldKeyInfo.virtue_formCode_FR903 || {}"
                />
                <!-- 坐诊时间 -->
                <custom-form-item
                  type="multiple-select"
                  prop="practice_time_formCode_FR903"
                  v-model="item.practice_time_formCode_FR903"
                  filterable
                  :options="originOptionsInfo.practice_time_formCode_FR903 || []"
                  :fieldInfo="showFormFieldKeyInfo.practice_time_formCode_FR903 || {}"
                />
                <!-- 次均门诊量 -->
                <custom-form-item
                  type="input"
                  prop="outpatient_service_day_number_formCode_FR903"
                  v-model="item.outpatient_service_day_number_formCode_FR903"
                  :fieldInfo="showFormFieldKeyInfo.outpatient_service_day_number_formCode_FR903 || {}"
                />
                <!-- 坐诊挂号费 -->
                <custom-form-item
                  type="input"
                  prop="register_price_formCode_FR903"
                  v-model="item.register_price_formCode_FR903"
                  :fieldInfo="showFormFieldKeyInfo.register_price_formCode_FR903 || {}"
                />
                <!-- 提前挂号率 -->
                <custom-form-item
                  type="input"
                  prop="register_advance_rate_formCode_FR903"
                  v-model="item.register_advance_rate_formCode_FR903"
                  :fieldInfo="showFormFieldKeyInfo.register_advance_rate_formCode_FR903 || {}"
                />
                <!-- 满号时间 -->
                <custom-form-item
                  type="select"
                  prop="fully_booked_time_formCode_FR903"
                  v-model="item.fully_booked_time_formCode_FR903"
                  :options="originOptionsInfo.fully_booked_time_formCode_FR903 || []"
                  :fieldInfo="showFormFieldKeyInfo.fully_booked_time_formCode_FR903 || {}"
                />
                <!-- 月度销售额 -->
                <custom-form-item
                  type="input"
                  prop="sales_month_amount_formCode_FR903"
                  v-model="item.sales_month_amount_formCode_FR903"
                  :fieldInfo="showFormFieldKeyInfo.sales_month_amount_formCode_FR903 || {}"
                />
                <!-- 挂号费提成 -->
                <custom-form-item
                  type="input"
                  prop="register_commission_formCode_FR903"
                  v-model="item.register_commission_formCode_FR903"
                  :fieldInfo="showFormFieldKeyInfo.register_commission_formCode_FR903 || {}"
                />
                <!-- 药费提成 -->
                <custom-form-item
                  type="input"
                  prop="drug_commission_formCode_FR903"
                  v-model="item.drug_commission_formCode_FR903"
                  :fieldInfo="showFormFieldKeyInfo.drug_commission_formCode_FR903 || {}"
                />
                <!-- 外治提成 -->
                <custom-form-item
                  type="input"
                  prop="physio_commission_formCode_FR903"
                  v-model="item.physio_commission_formCode_FR903"
                  :fieldInfo="showFormFieldKeyInfo.physio_commission_formCode_FR903 || {}"
                />
                <!-- 是否有编制 -->
                <custom-form-item
                  type="select"
                  prop="establishment_formCode_FR903"
                  v-model="item.establishment_formCode_FR903"
                  :options="originOptionsInfo.establishment_formCode_FR903 || []"
                  :fieldInfo="showFormFieldKeyInfo.establishment_formCode_FR903 || {}"
                />
              </div>
            </el-form>
          </div>
        </div>

        <!-- 辅助信息 -->
        <div v-show="activeTab === 'assistant'" class="tab-section">
          <el-form
            ref="assistantInfoForm"
            :model="formData"
            label-width="90px"
          >
            <div class="form-grid">
              <!-- 婚姻状况 -->
              <custom-form-item
                type="select"
                prop="is_marry_formCode_FR901"
                v-model="formData.is_marry_formCode_FR901"
                :options="originOptionsInfo.is_marry_formCode_FR901 || []"
                :fieldInfo="showFormFieldKeyInfo.is_marry_formCode_FR901 || {}"
              />
              <!-- 子女情况 -->
              <custom-form-item
                type="textarea"
                prop="children_formCode_FR901"
                v-model="formData.children_formCode_FR901"
                :fieldInfo="showFormFieldKeyInfo.children_formCode_FR901 || {}"
              />
              <!-- 家庭住址 -->
              <custom-form-item
                type="textarea"
                prop="address_formCode_FR901"
                v-model="formData.address_formCode_FR901"
                :fieldInfo="showFormFieldKeyInfo.address_formCode_FR901 || {}"
              />
              <!-- 爱好 -->
              <custom-form-item
                type="textarea"
                prop="interest_formCode_FR901"
                v-model="formData.interest_formCode_FR901"
                :fieldInfo="showFormFieldKeyInfo.interest_formCode_FR901 || {}"
              />
              <!-- 禁忌话题 -->
              <custom-form-item
                type="textarea"
                prop="sensitive_topic_formCode_FR901"
                v-model="formData.sensitive_topic_formCode_FR901"
                :fieldInfo="showFormFieldKeyInfo.sensitive_topic_formCode_FR901 || {}"
              />
            </div>
          </el-form>
        </div>

        <!-- 医生期望 -->
        <div v-show="activeTab === 'doctorWish'" class="tab-section">
          <el-form
            ref="doctorWishInfoForm"
            :model="formData"
            label-width="120px"
          >
            <div class="form-grid">
              <!-- 挂号费 -->
              <custom-form-item
                type="input"
                prop="register_price_formCode_FR902"
                v-model="formData.register_price_formCode_FR902"
                :fieldInfo="showFormFieldKeyInfo.register_price_formCode_FR902 || {}"
              />
              <!-- 挂号费提成 -->
              <custom-form-item
                type="input"
                prop="register_commission_formCode_FR902"
                v-model="formData.register_commission_formCode_FR902"
                :fieldInfo="showFormFieldKeyInfo.register_commission_formCode_FR902 || {}"
              />
              <!-- 药费提成 -->
              <custom-form-item
                type="input"
                prop="drug_commission_formCode_FR902"
                v-model="formData.drug_commission_formCode_FR902"
                :fieldInfo="showFormFieldKeyInfo.drug_commission_formCode_FR902 || {}"
              />
              <!-- 外治提成 -->
              <custom-form-item
                type="input"
                prop="physio_commission_formCode_FR902"
                v-model="formData.physio_commission_formCode_FR902"
                :fieldInfo="showFormFieldKeyInfo.physio_commission_formCode_FR902 || {}"
              />
              <!-- 坐诊医馆 -->
              <custom-form-item
                type="multiple-select"
                prop="practice_hospital_formCode_FR012"
                v-model="formData.practice_hospital_formCode_FR902"
                filterable
                :options="originOptionsInfo.practice_hospital_formCode_FR902 || []"
                :fieldInfo="showFormFieldKeyInfo.practice_hospital_formCode_FR902 || {}"
              />
              <!-- 坐诊时间 -->
              <custom-form-item
                type="multiple-select"
                prop="practice_time_formCode_FR012"
                v-model="formData.practice_time_formCode_FR902"
                filterable
                :options="originOptionsInfo.practice_time_formCode_FR902 || []"
                :fieldInfo="showFormFieldKeyInfo.practice_time_formCode_FR902 || {}"
              />
              <!-- 储备区域 -->
              <custom-form-item
                type="multiple-select"
                prop="reserve_area_formCode_FR012"
                v-model="formData.reserve_area_formCode_FR902"
                filterable
                :options="originOptionsInfo.reserve_area_formCode_FR902 || []"
                :fieldInfo="showFormFieldKeyInfo.reserve_area_formCode_FR902 || {}"
              />
              <!-- 自带患者能力 -->
              <custom-form-item
                type="select"
                prop="patient_acquisition_capacity_formCode_FR902"
                v-model="formData.patient_acquisition_capacity_formCode_FR902"
                :options="originOptionsInfo.patient_acquisition_capacity_formCode_FR902 || []"
                :fieldInfo="showFormFieldKeyInfo.patient_acquisition_capacity_formCode_FR902 || {}"
              />
              <!-- 预计到馆时间 -->
              <el-form-item
                v-if="(showFormFieldKeyInfo.estimated_arrival_date_formCode_FR902 || {}).isShow"
                :label="(showFormFieldKeyInfo.estimated_arrival_date_formCode_FR902 || {}).zhName"
              >
                <el-date-picker
                  style="width: 100%;"
                  v-model="formData.estimated_arrival_date_formCode_FR902"
                  type="date"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  size="small"
                  class="form-input"
                />
              </el-form-item>
              <!-- 预计合作属性 -->
              <custom-form-item
                type="select"
                prop="expected_cooperation_type_formCode_FR902"
                v-model="formData.expected_cooperation_type_formCode_FR902"
                :options="originOptionsInfo.expected_cooperation_type_formCode_FR902 || []"
                :fieldInfo="showFormFieldKeyInfo.expected_cooperation_type_formCode_FR902 || {}"
              />
              <!-- 医生需求 -->
              <custom-form-item
                type="textarea"
                prop="expectation_formCode_FR902"
                v-model="formData.expectation_formCode_FR902"
                :fieldInfo="showFormFieldKeyInfo.expectation_formCode_FR902 || {}"
              />
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const createFormCode = 'FR001'
const createSeePatientFormCode = 'FR015'
const baseInfoFormCode = 'FR900'
const seePatientFormCode = 'FR903'
const assistantInfoFormCode = 'FR901'
const doctorWishFormCode = 'FR902'
const doctorFeedbackFormCode = 'FR013'

import request from '@/utils/request'
import utils from '@/views/DoctorVisitLTC/utils/index'
import formFlow from '@/views/DoctorVisitLTC/common/formFlow'
import CustomFormItem from '@/views/DoctorVisitLTC/components/customFormItem/CustomFormItem.vue'

export default {
  name: 'AddClue',
  components: {
    CustomFormItem
  },
  data() {
    return {
      loading: false,
      createClueIsSuccess: false, // 创建线索是否成功
      instanceId: '', // 流程实例ID
      doctorId: '', // 医生ID
      stepCode: 'S020', // 步骤code
      stepId: '', // 步骤ID
      formCodeList: [],
      employeeOptions: [],
      employeeLoading: false,
      searchKeyword: '',
      // 是否展开更多线索信息
      isExpanded: false,
      // 当前激活的标签页
      activeTab: 'basic',
      createFormCode,
      createSeePatientFormCode,
      baseInfoFormCode,
      seePatientFormCode,
      assistantInfoFormCode,
      doctorWishFormCode,
      doctorFeedbackFormCode,
      // 基础表单数据
      formData: {
        assignTo: '', // 新增线索给
        follower: '', // 指定跟进人工号
        ['doctor_id_formCode_' + createFormCode]: '', // 医生ID
        ['doctor_name_formCode_' + createFormCode]: '', // 医生姓名
        ['sex_formCode_' + createFormCode]: '', // 性别
        // 基本信息
        ['phone_formCode_' + baseInfoFormCode]: '', // 手机号
        ['wxid_formCode_' + baseInfoFormCode]: '', // 微信号
        ['age_formCode_' + baseInfoFormCode]: '', // 年龄
        ['birth_formCode_' + baseInfoFormCode]: '', // 生日
        ['province_native_place_formCode_' + baseInfoFormCode]: '', // 籍贯省份
        ['school_formCode_' + baseInfoFormCode]: '', // 毕业院校
        ['aa_formCode_' + baseInfoFormCode]: '', // 职称
        ['ab_formCode_' + baseInfoFormCode]: '', // 荣誉称号
        ['inherit_formCode_' + baseInfoFormCode]: '', // 师承
        ['physio_type_formCode_' + baseInfoFormCode]: [], // 治疗方式
        ['showPhysioRate']: false, // 是否显示外治占比字段
        ['physio_rate_formCode_' + baseInfoFormCode]: '', // 外治占比
        ['income_month_amount_formCode_' + baseInfoFormCode]: '', // 月收入
        ['month_sale_amount_formCode_' + baseInfoFormCode]: '', // 月销售金额(自述)
        ['referrer_formCode_' + baseInfoFormCode]: '', // 介绍人
        // 辅助信息
        ['doctor_aid_id_formCode_' + assistantInfoFormCode]: '', // 辅助信息id
        ['is_marry_formCode_' + assistantInfoFormCode]: '', // 婚姻状况
        ['children_formCode_' + assistantInfoFormCode]: '', // 子女情况
        ['address_formCode_' + assistantInfoFormCode]: '', // 家庭住址
        ['interest_formCode_' + assistantInfoFormCode]: '', // 爱好
        ['sensitive_topic_formCode_' + assistantInfoFormCode]: '', // 禁忌话题
        // 期望信息
        ['doctor_expectation_id_formCode_' + doctorWishFormCode]: '', // 医生期望id
        ['register_price_formCode_' + doctorWishFormCode]: '', // 挂号费
        ['register_commission_formCode_' + doctorWishFormCode]: '', // 挂号费提成
        ['drug_commission_formCode_' + doctorWishFormCode]: '', // 药费提成
        ['physio_commission_formCode_' + doctorWishFormCode]: '', // 外治提成
        ['practice_hospital_formCode_' + doctorWishFormCode]: [], // 坐诊医馆
        ['practice_time_formCode_' + doctorWishFormCode]: [], // 坐诊时间
        ['expectation_formCode_' + doctorWishFormCode]: '', // 医生需求
        ['reserve_area_formCode_' + doctorWishFormCode]: [], // 储备区域
        ['patient_acquisition_capacity_formCode_']: '', // 自带患者能力
        ['estimated_arrival_date_formCode_']: '', // 预计到馆时间
        ['expected_cooperation_type_formCode_']: '', // 预计合作属性
      },
      areaList: [],
      cityList: [],
      fieldList: [],
      showFormFieldKeyInfo: {}, // 表单字段信息
      originOptionsInfo: {},
      // 坐诊信息
      seePatientList: [],
      activeSeePatientTabIndex: 0
    }
  },
  methods: {
    async getDoctorId() {
      let doctorId = ''
      try {
        const res = await request.get('/cluepool/doctor/createDoctorId', {}, '')
        if (res.code === 200) {
          doctorId = res.data || ''
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('获取医生id失败', error)
      }
      return doctorId
    },
    // 获取省市区json
    async getAreaList() {
      const params = {
        v: +new Date()
      }
      try {
        const res = await request.get('/cluepool/area.json', params, '')
        if (res.code === 200) {
          this.areaList = (res.data || []).map(item => ({
            ...item,
            list: (item.list || []).map(ite => ({
              name: ite.name,
              code: ite.code
            }))
          }))
          this.cityList = (res.data || []).map(item => ({
            ...item,
            list: (item.list || []).map(ite => ({
              name: ite.name,
              code: ite.code,
              list: (ite.list || []).map(it => ({
                name: it.name,
                code: it.code
              }))
            }))
          }))
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('获取省市区json失败', error)
      }
    },

    async getEmployeeOptions() {
      const params = {}
      try {
        const res = await request.get('/cluepool/pc/user/all', params, '')
        if(res.code === 200) {
          this.employeeOptions = res.data || []
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('请求员工列表数据请求失败', error)
      }
    },

    // 远程搜索员工
    remoteSearchEmployee(query) {
      if (query !== '') {
        this.employeeLoading = true
        this.searchKeyword = query
        // 模拟远程搜索延迟，优化用户体验
        setTimeout(() => {
          this.employeeLoading = false
        }, 200)
      } else {
        this.searchKeyword = ''
        this.employeeLoading = false
      }
    },

    async getFormFieldList(formCodeList) {
      try {
        const {
          formData,
          showFormFieldKeyInfo,
          originOptionsInfo,
          fieldList,
          optionsInfo
        } = await formFlow.getFormFieldList(formCodeList)
        const formIdOfAid = await formFlow.createFormId()
        const formIdOfExpectationId = await formFlow.createFormId()
        this.formData = {
          ...formData,
          ['doctor_aid_id_formCode_' + assistantInfoFormCode]: formIdOfAid,
          ['doctor_expectation_id_formCode_' + doctorWishFormCode]: formIdOfExpectationId,
          assignTo: '',
          follower: ''
        }
        this.originOptionsInfo = originOptionsInfo
        this.fieldList = fieldList
        this.showFormFieldKeyInfo = showFormFieldKeyInfo
        // console.log({formData, showFormFieldKeyInfo, originOptionsInfo, fieldList, optionsInfo})
      } catch (error) {
        console.log('获取表单字段信息失败:', error)
      }
    },

    // 表单字段change事件
    changeHandle(event, fieldKey, index) {
      const mapInfo = {
        'doctor_name_formCode_FR900': 'doctor_name_formCode_FR001',
        'doctor_name_formCode_FR001': 'doctor_name_formCode_FR900',
        'sex_formCode_FR900': 'sex_formCode_FR001',
        'sex_formCode_FR001': 'sex_formCode_FR900',
        'hospital_formCode_FR903': 'hospital_formCode_FR015',
        'hospital_formCode_FR015': 'hospital_formCode_FR903',
        'department_formCode_FR903': 'department_formCode_FR015',
        'department_formCode_FR015': 'department_formCode_FR903'
      }
      if (Object.keys(mapInfo).includes(fieldKey)) {
        if (index === undefined) {
          this.formData[mapInfo[fieldKey]] = event
        } else {
          this.seePatientList[index][mapInfo[fieldKey]] = event
        }
      }
    },

    // 改变年龄或出生日期 —— 双向联动计算
    changeAgeOrBirchdayHandle(event, type) {
      const ageKey = 'age_formCode_' + baseInfoFormCode
      const birthKey = 'birth_formCode_' + baseInfoFormCode

      if (type === 'age') {
        // 年龄 → 出生日期
        const age = Number(event)
        if (event === '' || event === null || event === undefined || isNaN(age) || age < 0) {
          // 输入非法或清空时，不清空出生日期（避免误操作）
          return
        }
        const today = new Date()
        const birthDate = new Date(today)
        birthDate.setFullYear(today.getFullYear() - Math.floor(age))
        const y = birthDate.getFullYear()
        const m = String(birthDate.getMonth() + 1).padStart(2, '0')
        const d = String(birthDate.getDate()).padStart(2, '0')
        this.formData[birthKey] = `${y}-${m}-${d}`
      } else if (type === 'birthday') {
        // 出生日期 → 年龄
        if (!event) {
          // 清空日期时不联动清除年龄
          return
        }
        const today = new Date()
        const birthDate = new Date(event)
        if (isNaN(birthDate.getTime())) return
        let age = today.getFullYear() - birthDate.getFullYear()
        const monthDiff = today.getMonth() - birthDate.getMonth()
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--
        }
        if (age < 0) age = 0
        this.formData[ageKey] = String(age)
      }
    },
    // 表单校验
    validateForm() {
      // 收集当前组件中所有存在的 form 引用
      const refs = []

      if (this.$refs.baseForm) {
        refs.push(this.$refs.baseForm)
      }

      const createRefs = this.$refs.seePatientCreateForm
      if (createRefs) {
        refs.push(...(Array.isArray(createRefs) ? createRefs : [createRefs]))
      }

      const tabRefs = this.$refs.seePatientTabForms
      if (tabRefs) {
        refs.push(...(Array.isArray(tabRefs) ? tabRefs : [tabRefs]))
      }

      // 展开的标签页表单（仅在 isExpanded 为 true 时存在）
      if (this.$refs.baseInfoForm) {
        refs.push(this.$refs.baseInfoForm)
      }
      if (this.$refs.assistantInfoForm) {
        refs.push(this.$refs.assistantInfoForm)
      }
      if (this.$refs.doctorWishInfoForm) {
        refs.push(this.$refs.doctorWishInfoForm)
      }

      if (!refs.length) {
        return Promise.resolve()
      }

      // 同时校验所有表单
      return Promise.all(
        refs.map(form => {
          return new Promise((resolve, reject) => {
            form.validate((valid) => {
              valid ? resolve() : reject(new Error('表单校验失败'))
            })
          })
        })
      )
    },

    // 创建流程实例
    async createFlowHandle() {
      this.loading = true
      try {
        const { fieldList, formData, seePatientList } = this || {}
        const resultFormData = []
        const createFlowFormCodeList = [createFormCode, createSeePatientFormCode]
        for (const formCode of createFlowFormCodeList) {
          if (formCode === createSeePatientFormCode) {
            // 坐诊信息
            seePatientList.forEach(el => {
              resultFormData.push({
                formCode,
                fieldData: fieldList.filter(item => item.formCode === formCode).map((item, index) => {
                  let value = []
                  if (['doctor_id'].includes(item.fieldName)) {
                    value = utils.isEmpty(this.doctorId) ? [] : [this.doctorId]
                  } else if (['hospital', 'department'].includes(item.fieldName)) {
                    // 需要过滤掉空格和换行符
                    value = utils.isEmpty(el[item.resultFieldName]) ? [] : [el[item.resultFieldName].replace(/\s+/g, '')]
                  } else {
                    value = utils.isEmpty(el[item.resultFieldName]) ? [] : [el[item.resultFieldName]]
                  }
                  return {
                    formFieldCode: item.fieldCode,
                    // fieldName: item.fieldName,
                    // zhName: item.zhName,
                    value
                  }
                })
              })
            })
          } else {
            // 非坐诊信息表单
            resultFormData.push({
              formCode,
              fieldData: fieldList.filter(item => item.formCode === formCode).map(item => {
                let value = []
                if (['doctor_id'].includes(item.fieldName)) {
                  value = utils.isEmpty(this.doctorId) ? [] : [this.doctorId]
                } else if (['work_number'].includes(item.fieldName)) {
                  // 当前跟进人
                  if (this.isCreateToFollower) {
                    // 指定跟进人
                    value = utils.isEmpty(formData.follower) ? [] : [formData.follower]
                  } else {
                    // 公海
                    value = []
                  }
                } else if (['doctor_name'].includes(item.fieldName)) {
                  // 需要过滤掉空格和换行符
                  value = utils.isEmpty(formData[item.resultFieldName]) ? [] : [formData[item.resultFieldName].replace(/\s+/g, '')]
                } else {
                  value = utils.isEmpty(formData[item.resultFieldName]) ? [] : [formData[item.resultFieldName]]
                }
                return {
                  formFieldCode: item.fieldCode,
                  // fieldName: item.fieldName,
                  // zhName: item.zhName,
                  value
                }
              })
            })
          }
        }
        const params = {
          flowCode: 'F001', // 流程编号
          flowInstanceId: this.instanceId, // 流程实例ID
          followAction: this.stepCode, // 下一步步骤code
          formData: resultFormData
        }
        let reqSuccess = false
        try {
          const res = await request.post('/cluepool/pc/form/startFlow', params, '')
          if (res.code === 200) {
            this.stepId = (((res.data || {}).tasks || []).sort((a, b) => b.stepId - a.stepId)[0] || {}).stepId || ''
            reqSuccess = true
          } else {
            this.$message.error(res.message)
          }
        } catch (error) {
          console.log('表单校验失败:', error)
        }
        return reqSuccess
      } catch (error) {
        console.log('创建流程组装数据失败:', error)
        return false
      } finally {
        this.loading = false
      }
    },

    // 创建坐诊信息表单数据
    async createSeePatientFormData () {
      const formId = await formFlow.createFormId()
      this.seePatientList.push({
        uuid: utils.generateUUID(),
        ['doctor_practice_id_formCode_' + createSeePatientFormCode]: formId, // 坐诊地点id
        ['doctor_practice_id_formCode_' + seePatientFormCode]: formId, // 坐诊地点id
        ['hospital_formCode_' + createSeePatientFormCode]: '', // 坐诊医院
        ['hospital_formCode_' + seePatientFormCode]: '', // 坐诊医院
        ['province_formCode_' + seePatientFormCode]: [], // 医院行政区域
        ['department_formCode_' + createSeePatientFormCode]: '', // 医院科室
        ['department_formCode_' + seePatientFormCode]: '', // 医院科室
        ['synopsis_formCode_' + seePatientFormCode]: '', // 医生简介
        ['virtue_formCode_' + seePatientFormCode]: '', // 擅长
        ['hospital_address_formCode_' + seePatientFormCode]: '', // 医院详细地址
        ['practice_time_formCode_' + seePatientFormCode]: [], // 坐诊时间
        ['outpatient_service_day_number_formCode_' + seePatientFormCode]: '',  // 次门诊量
        ['register_price_formCode_' + seePatientFormCode]: '', // 坐诊挂号费
        ['register_advance_rate_formCode_' + seePatientFormCode]: '', // 提前挂号率
        ['fully_booked_time_formCode_' + seePatientFormCode]: '', // 满号时间
        ['sales_month_amount_formCode_' + seePatientFormCode]: '', // 月度销售额
        ['register_commission_formCode_' + seePatientFormCode]: '', // 挂号费提成
        ['drug_commission_formCode_' + seePatientFormCode]: '', // 药费提成
        ['physio_commission_formCode_' + seePatientFormCode]: '', // 外治提成
        ['establishment_formCode_' + seePatientFormCode]: '', // 是否有编制
      })
    },

    // 删除坐诊信息表单数据
    async deleteSeePatientFormData(item, index) {
      // 二次确认
      const confirm = await utils.messageBoxConfirm({ title: '提示', message: '是否删除该坐诊信息' + (index + 1) + '？' })
      if (!confirm) return
      this.seePatientList = this.seePatientList.filter(el => el.uuid !== item.uuid)
      if (this.seePatientList.length <= this.activeSeePatientTabIndex) {
        this.activeSeePatientTabIndex = this.activeSeePatientTabIndex - 1
      }
    },

    // 提交编辑线索数据
    async submitEditOrderHandle() {
      this.loading = true
      try {
        const { fieldList, formData, doctorId, seePatientList } = this || {}
        let resultFormCodeList = [baseInfoFormCode, seePatientFormCode]
        // 创建到跟进人
        if (this.isCreateToFollower) {
          resultFormCodeList = [
            ...resultFormCodeList,
            assistantInfoFormCode,
            doctorWishFormCode,
            doctorFeedbackFormCode
          ]
        }
        const resultFormData = []
        for (const formCode of resultFormCodeList) {
          if (formCode === seePatientFormCode) {
            // 坐诊信息
            seePatientList.forEach(el => {
              resultFormData.push({
                formCode: seePatientFormCode,
                fieldData: fieldList.filter(item => item.formCode === seePatientFormCode).map(item => {
                  let value = []
                  // 行政区省市区相关字段
                  if (['province', 'city', 'region', 'province_name', 'city_name', 'region_name'].includes(item.fieldName)) {
                    const valueList = el['province_formCode_' + seePatientFormCode] || []
                    const labelList = []
                    if (valueList && valueList.length > 0) {
                      const provinceInfo = this.cityList.find(ite => Number(ite.code) === Number(valueList[0]))
                      if (provinceInfo) {
                        labelList[0] = provinceInfo.name || ''
                        const cityInfo = provinceInfo.list.find(ite => Number(ite.code) === Number(valueList[1]))
                        if (cityInfo) {
                          labelList[1] = cityInfo.name || ''
                          const regionInfo = cityInfo.list.find(ite => Number(ite.code) === Number(valueList[2]))
                          if (regionInfo) {
                            labelList[2] = regionInfo.name || ''
                          }
                        }
                      }
                    }
                    switch (item.fieldName) {
                      case 'province':
                        value = utils.isEmpty(valueList[0]) ? [] : [(valueList[0]).toString()]
                        break
                      case 'city':
                        value = utils.isEmpty(valueList[1]) ? [] : [(valueList[1]).toString()]
                        break
                      case 'region':
                        value = utils.isEmpty(valueList[2]) ? [] : [(valueList[2]).toString()]
                        break
                      case 'province_name':
                        value = utils.isEmpty(labelList[0]) ? [] : [(labelList[0]).toString()]
                        break
                      case 'city_name':
                        value = utils.isEmpty(labelList[1]) ? [] : [(labelList[1]).toString()]
                        break
                      case 'region_name':
                        value = utils.isEmpty(labelList[2]) ? [] : [(labelList[2]).toString()]
                        break
                    }
                  } else if (['doctor_id'].includes(item.fieldName)) {
                    value = utils.isEmpty(doctorId) ? [] : [doctorId]
                  } else if (['hospital', 'department'].includes(item.fieldName)) {
                    // 需要过滤掉空格和换行符
                    value = utils.isEmpty(el[item.resultFieldName]) ? [] : [el[item.resultFieldName].replace(/\s+/g, '')]
                  } else {
                    const isArray = Array.isArray(el[item.resultFieldName])
                    if (item.inputType === 2) {
                      // 多选
                      value = utils.isEmpty(el[item.resultFieldName]) ? [] : (isArray ? el[item.resultFieldName] : [el[item.resultFieldName]])
                    } else {
                      value = utils.isEmpty(el[item.resultFieldName]) ? [] : (isArray ? el[item.resultFieldName] : [el[item.resultFieldName]])
                    }
                  }
                  return {
                    formFieldCode: item.fieldCode,
                    formFieldName: item.fieldName,
                    formZhName: item.zhName,
                    value
                  }
                })
              })
            })
          } else {
            resultFormData.push({
              formCode,
              fieldData: fieldList.filter(item => item.formCode === formCode).map(item => {
                let value = []
                // 籍贯相关字段
                if (['province_native_place', 'province_native_place_name', 'city_native_place', 'city_native_place_name'].includes(item.fieldName)) {
                  const valueList = formData['province_native_place_formCode_' + baseInfoFormCode] || []
                  const labelList = []
                  if (valueList && valueList.length > 0) {
                    const provinceInfo = this.cityList.find(ite => Number(ite.code) === Number(valueList[0]))
                    if (provinceInfo) {
                      labelList[0] = provinceInfo.name || ''
                      const cityInfo = provinceInfo.list.find(ite => Number(ite.code) === Number(valueList[1]))
                      if (cityInfo) {
                        labelList[1] = cityInfo.name || ''
                      }
                    }
                  }
                  switch (item.fieldName) {
                    case 'province_native_place':
                      value = utils.isEmpty(valueList[0]) ? [] : [(valueList[0]).toString()]
                      break
                    case 'city_native_place':
                      value = utils.isEmpty(valueList[1]) ? [] : [(valueList[1]).toString()]
                      break
                    case 'province_native_place_name':
                      value = utils.isEmpty(labelList[0]) ? [] : [(labelList[0]).toString()]
                      break
                    case 'city_native_place_name':
                      value = utils.isEmpty(labelList[1]) ? [] : [(labelList[1]).toString()]
                      break
                  }
                } else if (['doctor_id'].includes(item.fieldName)) {
                  // 处理doctor_id字段
                  value = utils.isEmpty(doctorId) ? [] : [doctorId]
                } else if (['doctor_name'].includes(item.fieldName)) {
                  // 需要过滤掉空格和换行符
                  value = utils.isEmpty(formData[item.resultFieldName]) ? [] : [formData[item.resultFieldName].replace(/\s+/g, '')]
                } else if (item.fieldName === 'expectation') {
                  // 全局的医生需求
                  value = utils.isEmpty(formData['expectation_formCode_' + doctorWishFormCode])
                          ? []
                          : [formData['expectation_formCode_' + doctorWishFormCode]]
                } else {
                  const isArray = Array.isArray(formData[item.resultFieldName])
                  if (item.inputType === 2) {
                    // 多选
                    value = utils.isEmpty(formData[item.resultFieldName]) ? [] : (isArray ? formData[item.resultFieldName] : [formData[item.resultFieldName]])
                  } else {
                    value = utils.isEmpty(formData[item.resultFieldName]) ? [] : (isArray ? formData[item.resultFieldName] : [formData[item.resultFieldName]])
                  }
                }
                return {
                  formFieldCode: item.fieldCode,
                  formFieldName: item.fieldName,
                  formZhName: item.zhName,
                  value
                }
              })
            })
          }
        }
        const params = this.isCreateToFollower ? {
          flowInstanceId: this.instanceId,
          followAction: this.stepCode,
          formData: resultFormData,
          stepCode: this.stepCode,
          stepId: this.stepId
        } : {
          formData: resultFormData
        }
        const api = this.isCreateToFollower ? 'submitFormData' : 'simpleSubmitFormData'
        try {
          const res = await formFlow[api](params)
          return res.code === 200
        } catch (error) {
          console.log('编辑医生信息失败', error)
          return false
        }
      } catch (error) {
        console.log('提交编辑线索数据失败:', error)
        return false
      } finally {
        this.loading = false
      }
    },

    // 表单提交处理
    async submitHandle() {
      try {
        await this.validateForm()
        let reqSuccess = false
        // 创建线索到指定跟进人
        if (this.isCreateToFollower) {
          // 创建线索（如果没有创建成功，则需要重新创建，如果创建成功了，则跳过创建，直接执行submitEditOrderHandle）
          if (!this.createClueIsSuccess) {
            reqSuccess = await this.createFlowHandle()
            this.createClueIsSuccess = reqSuccess
          }
          if (reqSuccess || this.createClueIsSuccess) {
            reqSuccess = await this.submitEditOrderHandle()
          }
        } else {
          // 创建线索到公海
          reqSuccess = await this.submitEditOrderHandle()
        }
        return reqSuccess
      } catch (error) {
        return false
      }
    },

    // 清除所有表单的校验状态（用于加载完成后清除初始校验提示）
    clearAllValidation() {
      // 清除 baseForm 校验
      if (this.$refs.baseForm) {
        this.$refs.baseForm.clearValidate()
      }
      // 清除 seePatientCreateForm 校验（v-for 动态渲染，可能是数组）
      const createRefs = this.$refs.seePatientCreateForm
      if (createRefs) {
        const refs = Array.isArray(createRefs) ? createRefs : [createRefs]
        refs.forEach(form => form.clearValidate())
      }
    },

    // 清除展开的 tab 内表单的校验状态
    clearTabFormValidation() {
      const tabFormRefs = ['baseInfoForm', 'assistantInfoForm', 'doctorWishInfoForm']
      tabFormRefs.forEach(ref => {
        if (this.$refs[ref]) {
          this.$refs[ref].clearValidate()
        }
      })
      // 清除 seePatientTabForms 校验（v-for 动态渲染，可能是数组）
      const tabRefs = this.$refs.seePatientTabForms
      if (tabRefs) {
        const refs = Array.isArray(tabRefs) ? tabRefs : [tabRefs]
        refs.forEach(form => form.clearValidate())
      }
    }
  },
  async created() {
    try {
      this.loading = true
      const formCodeList = [createFormCode, createSeePatientFormCode, baseInfoFormCode, seePatientFormCode, assistantInfoFormCode, doctorWishFormCode, doctorFeedbackFormCode]
      await this.getFormFieldList(formCodeList)
      this.formCodeList = formCodeList
      this.instanceId = await formFlow.createFlow()
      this.doctorId = await this.getDoctorId()
      this.seePatientList = []
      await this.createSeePatientFormData()
      await this.getAreaList()
      await this.getEmployeeOptions()
    } catch (error) {
      console.log('获取表单字段信息失败:', error)
    } finally {
      this.loading = false
      // 加载完成后清除初始校验状态，避免页面加载时出现校验错误提示
      this.$nextTick(() => {
        this.clearAllValidation()
      })
    }
  },
  props: {
    roleType: {
      type: [String, Number],
      default: 0
    }
  },
  computed: {
    // 远程搜索过滤后的员工列表
    filteredEmployeeOptions() {
      if (!this.searchKeyword) {
        return []
      }
      const keyword = this.searchKeyword.toLowerCase()
      return this.employeeOptions.filter(item =>
        (item.nickName || '').toString().toLowerCase().includes(keyword) ||
        (item.workNumber || '').toString().toLowerCase().includes(keyword)
      ).slice(0, 60)
    },
    // 是否创建到指定跟进人
    isCreateToFollower() {
      return this.formData.assignTo === 'follower'
    }
  },
  watch: {
    // 展开更多线索信息时，清除 tab 内表单的初始校验
    isExpanded(val) {
      if (val) {
        this.$nextTick(() => {
          this.clearTabFormValidation()
        })
      }
    },
    'formData.assignTo'(newVal) {
      // 如果是创建到公海，且当前是辅助信息/医生需求，则切换到基础信息
      if (newVal === 'public' && ['assistant', 'doctorWish'].includes(this.activeTab)) {
        this.activeTab = 'basic'
      }
    }
  }
}
</script>

<style scoped lang="less">
.add-clue {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 200px);
  overflow: auto;
  .add-clue-title {
    margin: 4px 0 6px;
    padding: 2px 10px;
    font-size: 14px;
    font-weight: 600;
    color: #1F2329;
    border-left: 4px solid #1989FA;
  }
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

// 基础信息表单
.base-form {
  padding: 16px 40px 0 20px;

  .form-grid {
    position: relative;
    .el-icon-delete {
      position: absolute;
      top: 12px;
      right: -26px;
      font-size: 18px;
      cursor: pointer;
    }
  }

  .add-see-patient-btn {
    display: inline-block;
    padding: 8px 10px;
    font-size: 14px;
    color: #1890FF;
    border: 1px solid #1890ff;
    border-radius: 3px;
    cursor: pointer;
  }
}

// 标签页切换按钮
.tab-toggle {
  padding: 20px 20px 20px 20px;
  border-bottom: 1px solid #E8E8E8;

  .toggle-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #1890FF;
    font-size: 14px;
    cursor: pointer;
    user-select: none;

    i {
      font-size: 12px;
    }
  }
}

// 展开的内容区域
.expand-content {
  padding: 10px 40px 16px 20px;

  // 标签页样式
  .clue-tabs {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #fff;

    /deep/ .el-tabs__header {
      margin-left: 0;
      margin-bottom: 16px;
    }

    /deep/ .el-tabs__nav-wrap::after {
      height: 1px;
      background-color: #E8E8E8;
    }

    /deep/ .el-tabs__item {
      font-size: 14px;
      color: #667182;

      &.is-active {
        color: #1890FF;
        font-weight: 500;
      }
    }

    /deep/ .el-tabs__active-bar {
      background-color: #1890FF;
    }
  }
  
  // 标签页内容区域
  .tab-content-area {
    .tab-section {
      padding-top: 4px;
      margin-bottom: 24px;
  
      &:last-child {
        margin-bottom: 0;
      }

      // 坐诊信息标签页
      .see-patient-tab {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 4px 0 8px;

        .see-patient-tab-content {
          display: flex;
          align-items: center;
          gap: 4px;
          border: 1px solid #E0E0E0;
          border-radius: 4px;
          overflow: hidden;

          .see-patient-tab-item {
            display: inline-block;
            padding: 8px;
            font-size: 13px;
            color: #667182;
            cursor: pointer;
            border-right: 1px solid #E0E0E0;

            &:last-child {
              border-right: none;
            }

            &.active {
              color: #fff;
              background-color: #1890FF;
            }
          }
        }
      }
    }
  }
  
}

// 全局 el-tabs 样式覆盖
/deep/ .el-tabs {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  
  .el-tabs__header {
    padding-left: 0;
  }
}
</style>
